import { RectLayout, Area } from "../GeometricLayout";
import getContentArea from "../getContentArea";

/**
 * An expensive function to calculate most state information for a contenteditable div.
 *
 * @param div
 * @returns the style, boundingClientRect, scroll positions, content area, mirror style, border and padding of the text area
 */
export default function calculateContentEditable(div: HTMLDivElement): {
  boundingClientRect: RectLayout;
  scrollTop: number;
  scrollLeft: number;
  contentArea: Area;
  mirrorStyle: { [K in any]: never };
  scrollHeight: number;
  scrollWidth: number;
  border: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
  padding: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
} {
  const computedStyle = window.getComputedStyle(div);

  // Destructured and reassigned to separate from the DOMRect object
  const { top, left, height, width } = div.getBoundingClientRect();
  const boundingClientRect: RectLayout = {
    top,
    left,
    height,
    width,
  };
  const {
    scrollTop,
    scrollLeft,
    offsetHeight,
    offsetWidth,
    clientHeight,
    clientWidth,
  } = div;

  return {
    boundingClientRect,
    scrollTop,
    scrollLeft,
    contentArea: getContentArea(
      { offsetHeight, offsetWidth, clientHeight, clientWidth },
      computedStyle
    ),
    mirrorStyle: {},
    scrollHeight: div.scrollHeight,
    scrollWidth: div.scrollWidth,
    border: {
      top: Number.parseFloat(computedStyle.borderTopWidth),
      right: Number.parseFloat(computedStyle.borderRightWidth),
      bottom: Number.parseFloat(computedStyle.borderBottomWidth),
      left: Number.parseFloat(computedStyle.borderLeftWidth),
    },
    padding: {
      top: Number.parseFloat(computedStyle.paddingTop),
      right: Number.parseFloat(computedStyle.paddingRight),
      bottom: Number.parseFloat(computedStyle.paddingBottom),
      left: Number.parseFloat(computedStyle.paddingLeft),
    },
  };
}
